import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  ConfigProvider,
  Form,
  Input,
  Space,
  Select,
  Switch,
  Collapse,
} from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import 'moment-timezone';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import { FieldData } from 'rc-field-form/lib/interface';
import {
  createFertilizationScheduleRequest,
  getKnowledgeRequest,
} from 'modules/knowledgeModule/requests/knowledgeRequests';
import TextEditor from 'modules/layoutModule/components/TextEditor/TextEditor';
import FormFileUpload from 'modules/galleryModules/components/FormFileUpload';
import copyToClipboard from 'helpers/copyToClipboard';

const { Panel } = Collapse;
const { TextArea } = Input;

const FertilizationScheduleAdd = (): JSX.Element => {
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [form] = Form.useForm();
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage2, setFileImage2] = useState<string | null>(null);
  const [fileImage3, setFileImage3] = useState<string | null>(null);
  const [fileImage4, setFileImage4] = useState<string | null>(null);
  const [fileImage5, setFileImage5] = useState<string | null>(null);
  const [fileImage6, setFileImage6] = useState<string | null>(null);
  const [fileImage7, setFileImage7] = useState<string | null>(null);

  const [file1, setFile1] = useState<string | null>(null);
  const [file2, setFile2] = useState<string | null>(null);
  const [file3, setFile3] = useState<string | null>(null);
  const [file4, setFile4] = useState<string | null>(null);
  const [file5, setFile5] = useState<string | null>(null);

  const [fields, setFields] = useState<FieldData[]>([]);
  const [plants, setPlants] = useState([]);

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const onContentEdit = (e: string, field: string) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
  };

  useEffect(() => {
    getKnowledgeRequest().then((response) => {
      if (response.data) {
        const sections = response.data.map(
          (section: { name: string; id: number }) => {
            return {
              label: section.name,
              value: section.id,
            };
          }
        );
        sections.unshift({ label: '', value: '' });
        setPlants(sections);
      }
    });
  }, []);

  const onSubmitForm = (values: any) => {
    toggleButtonLoading(true);
    createFertilizationScheduleRequest(values).then(() =>
      toggleButtonLoading(false)
    );
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
  };

  const updateFile = (
    e: string,
    field: string,
    coverMethod: (value: string) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/fertilization-schedule">Harmonogramy</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/fertilization-schedule/add">+</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <div className="site-layout-background">
        <ConfigProvider locale={plPL}>
          <Form
            layout="vertical"
            validateMessages={validateMessages}
            onFinish={onSubmitForm}
            form={form}
            fields={fields}
          >
            <Form.Item
              name="fileImage1"
              label="Piktogram biały"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <FormCoverUpload
                cover={fileImage1}
                setCover={(e) => updateCover(e, 'fileImage1', setFileImage1)}
                isNew
                field="fileImage1"
                number={1}
                hideTags
                originalFile
              />
            </Form.Item>
            <Form.Item
              name="fileImage2"
              label="Piktogram zielony ciemny"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <FormCoverUpload
                cover={fileImage2}
                setCover={(e) => updateCover(e, 'fileImage2', setFileImage2)}
                isNew
                field="fileImage2"
                number={2}
                hideTags
                originalFile
              />
            </Form.Item>

            <Form.Item
              name="name"
              label="Nazwa w sliderze"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item name="plants" label="Połącz z nawożeniem uprawy">
              <Select
                showSearch
                placeholder="Wybierz harmonogram nawożenia"
                optionFilterProp="children"
                options={plants}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    const label = option?.label as string;
                    return label.toLowerCase().includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>


            <Form.Item name="name2" label="Nazwa przycisku w nawożeniu uprawy">
              <Input />
            </Form.Item>


            <fieldset className="fieldset no-bottom">
              <Form.Item
                name="fileImage3"
                label="Okładka (wszystkie nawozy)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage3}
                  setCover={(e) => updateCover(e, 'fileImage3', setFileImage3)}
                  isNew
                  field="fileImage3"
                  number={3}
                  hideTags
                  dontResize
                />
              </Form.Item>
              <Form.Item
                name="fileDownloadAll"
                label="Plik do pobrania (wszystkie nawozy)"
              >
                <FormFileUpload
                  file={file1}
                  setFile={(e) => updateFile(e, 'fileDownloadAll', setFile1)}
                  isNew
                  field="file1"
                />
              </Form.Item>
              <Form.Item name="descriptionAll" label="Opis (wszystkie nawozy)">
                {/* @ts-ignore */}
                <TextEditor
                  onChange={(e) => onContentEdit(e, 'descriptionAll')}
                  disableGallery
                />
              </Form.Item>
            </fieldset>

            <fieldset className="fieldset no-bottom">
              <Form.Item
                name="fileImage4"
                label="Okładka (nawozy dwuskładnikowe)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage4}
                  setCover={(e) => updateCover(e, 'fileImage4', setFileImage4)}
                  isNew
                  field="fileImage4"
                  number={4}
                  hideTags
                  dontResize
                />
              </Form.Item>
              <Form.Item
                name="fileDownloadRed"
                label="Plik do pobrania (nawozy dwuskładnikowe)"
              >
                <FormFileUpload
                  file={file2}
                  setFile={(e) => updateFile(e, 'fileDownloadRed', setFile2)}
                  isNew
                  field="file2"
                />
              </Form.Item>
              <Form.Item
                name="descriptionRed"
                label="Opis (nawozy dwuskładnikowe)"
              >
                {/* @ts-ignore */}
                <TextEditor
                  onChange={(e) => onContentEdit(e, 'descriptionRed')}
                  disableGallery
                />
              </Form.Item>
            </fieldset>

            <fieldset className="fieldset no-bottom">
              <Form.Item
                name="fileImage5"
                label="Okładka (nawozy azotowe)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage5}
                  setCover={(e) => updateCover(e, 'fileImage5', setFileImage5)}
                  isNew
                  field="fileImage5"
                  number={5}
                  hideTags
                  dontResize
                />
              </Form.Item>
              <Form.Item
                name="fileDownloadBlue"
                label="Plik do pobrania (nawozy azotowe)"
              >
                <FormFileUpload
                  file={file3}
                  setFile={(e) => updateFile(e, 'fileDownloadBlue', setFile3)}
                  isNew
                  field="file3"
                />
              </Form.Item>
              <Form.Item name="descriptionBlue" label="Opis (nawozy azotowe)">
                {/* @ts-ignore */}
                <TextEditor
                  onChange={(e) => onContentEdit(e, 'descriptionBlue')}
                  disableGallery
                />
              </Form.Item>
            </fieldset>

            <fieldset className="fieldset no-bottom">
              <Form.Item
                name="fileImage6"
                label="Okładka (nawozy azotowe z siarką)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage6}
                  setCover={(e) => updateCover(e, 'fileImage6', setFileImage6)}
                  isNew
                  field="fileImage6"
                  number={6}
                  hideTags
                  dontResize
                />
              </Form.Item>
              <Form.Item
                name="fileDownloadYellow"
                label="Plik do pobrania (nawozy azotowe z siarką)"
              >
                <FormFileUpload
                  file={file4}
                  setFile={(e) => updateFile(e, 'fileDownloadYellow', setFile4)}
                  isNew
                  field="file4"
                />
              </Form.Item>
              <Form.Item
                name="descriptionYellow"
                label="Opis (nawozy azotowe z siarką)
"
              >
                {/* @ts-ignore */}
                <TextEditor
                  onChange={(e) => onContentEdit(e, 'descriptionYellow')}
                  disableGallery
                />
              </Form.Item>
            </fieldset>

            <fieldset className="fieldset no-bottom">
              <Form.Item
                name="fileImage7"
                label="Okładka (nawozy wieloskładnikowe)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <FormCoverUpload
                  cover={fileImage7}
                  setCover={(e) => updateCover(e, 'fileImage7', setFileImage7)}
                  isNew
                  field="fileImage7"
                  number={7}
                  hideTags
                  dontResize
                />
              </Form.Item>
              <Form.Item
                name="fileDownloadGreen"
                label="Plik do pobrania (nawozy wieloskładnikowe)"
              >
                <FormFileUpload
                  file={file5}
                  setFile={(e) => updateFile(e, 'fileDownloadGreen', setFile5)}
                  isNew
                  field="file5"
                />
              </Form.Item>
              <Form.Item
                name="descriptionGreen"
                label="Opis (nawozy wieloskładnikowe)"
              >
                {/* @ts-ignore */}
                <TextEditor
                  onChange={(e) => onContentEdit(e, 'descriptionGreen')}
                  disableGallery
                />
              </Form.Item>
            </fieldset>



            <Form.Item
              name="sortOrder"
              label="Kolejność"
              rules={[
                {
                  required: true,
                },
                {
                  validator: async (_, value) => {
                    if (value) {
                      if (
                        (value.length > 5 ||
                          !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                        value.length > 0
                      ) {
                        return Promise.reject(
                          new Error('Proszę podać poprawną wartość!')
                        );
                      }
                    }
                  },
                },
              ]}
            >
              <Input
                style={{
                  width: '100px',
                }}
              />
            </Form.Item>

            <div className="tables-collapse">
              <Collapse defaultActiveKey={[]}>
                <Panel header="Tabelka 1" key="1" forceRender>
                  <Form.Item name="table1" label="Tabelka 1">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#1')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#1
                  </Button>
                </Panel>
                <Panel header="Tabelka 2" key="2" forceRender>
                  <Form.Item name="table2" label="Tabelka 2">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#2')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#2
                  </Button>
                </Panel>
                <Panel header="Tabelka 3" key="3" forceRender>
                  <Form.Item name="table3" label="Tabelka 3">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#3')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#3
                  </Button>
                </Panel>
                <Panel header="Tabelka 4" key="4" forceRender>
                  <Form.Item name="table4" label="Tabelka 4">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#4')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#4
                  </Button>
                </Panel>
                <Panel header="Tabelka 5" key="5" forceRender>
                  <Form.Item name="table5" label="Tabelka 5">
                    <TextArea rows={4} />
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => copyToClipboard('TABELKA#5')}
                    style={{ padding: 0, margin: 0 }}
                  >
                    TABELKA#5
                  </Button>
                </Panel>
              </Collapse>
            </div>

            <Form.Item
              name="isActive"
              label="Widoczność"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={isSaveButtonLoading}
                >
                  Zapisz
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>
    </>
  );
};

export default FertilizationScheduleAdd;
